const playSound = async () => {
  return false;
};

export default playSound;
